// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useEffect, useRef } from 'react';
import TabTrap from '../tab-trap/index';
import { getFirstFocusable, getLastFocusable } from './utils';
export default function FocusLock(_a) {
  var className = _a.className,
      disabled = _a.disabled,
      autoFocus = _a.autoFocus,
      children = _a.children;
  var containerRef = useRef(null);

  var focusFirst = function focusFirst() {
    var _a;

    if (containerRef.current) {
      (_a = getFirstFocusable(containerRef.current)) === null || _a === void 0 ? void 0 : _a.focus();
    }
  };

  var focusLast = function focusLast() {
    var _a;

    if (containerRef.current) {
      (_a = getLastFocusable(containerRef.current)) === null || _a === void 0 ? void 0 : _a.focus();
    }
  };

  useEffect(function () {
    if (autoFocus) {
      focusFirst();
    }
  }, [autoFocus]);
  return React.createElement(React.Fragment, null, React.createElement(TabTrap, {
    disabled: disabled,
    focusNextCallback: focusLast
  }), React.createElement("div", {
    className: className,
    ref: containerRef
  }, children), React.createElement(TabTrap, {
    disabled: disabled,
    focusNextCallback: focusFirst
  }));
}